import axios from 'axios'
import { alertDanger } from 'utils/toast'

const api = axios.create({
  baseURL: process.env.REACT_APP_SERVICES_URL,
  timeout: 30000,
})

api.interceptors.request.use(
  async (config) => {
    const token = window.localStorage.getItem('token')

    const locales = window.localStorage.getItem('@StarBem:lang')
    const valueLocale = locales === 'pt' || !locales ? 'pt-BR' : 'en-US'

    config.headers.Authorization = token
      ? `Bearer ${token}`
      : `Basic ${process.env.REACT_APP_API_KEY}`

    config.headers['x-app'] = 'doctor_portal'
    config.headers['Accept-Language'] = valueLocale

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    // `error.response` é undefined em falha de rede e em timeout (30s). Sem a
    // guarda, o destructuring lança dentro do interceptor e o chamador recebe um
    // TypeError no lugar do erro real do axios.
    const status = error.response?.status

    // Sem barra inicial de propósito: as rotas do serviço são passadas ora como
    // `/conversations/v1/...`, ora como `conversations/v1/...`.
    const isConversationsRoute =
      error.config?.url?.includes('conversations/v1') ?? false

    // `403` em rota de conversa é sinal de negócio, não de sessão inválida: o
    // SDK e a API usam 403 para "a participação mudou" e "esse anexo é de outro
    // par". Deslogar aí tirava o profissional do sistema inteiro no meio do
    // atendimento por causa de um estado esperado do chat.
    const isSessionError =
      (status === 403 || status === 401) && !isConversationsRoute

    if (isSessionError) {
      window.localStorage.clear()
      alertDanger('Sua sessão expirou! Faça login novamente.')

      setTimeout(() => {
        window.location.reload()
      }, 1500)
    }

    return Promise.reject(error)
  }
)

export default api
